export default __webpack_public_path__ + "static/pandanwangi-30da3f781d95b9e97c2e0e1d10c8f967.png";